import { render, staticRenderFns } from "./Monitor.vue?vue&type=template&id=57d72a95&scoped=true&"
import script from "./Monitor.vue?vue&type=script&lang=js&"
export * from "./Monitor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d72a95",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57d72a95')) {
      api.createRecord('57d72a95', component.options)
    } else {
      api.reload('57d72a95', component.options)
    }
    module.hot.accept("./Monitor.vue?vue&type=template&id=57d72a95&scoped=true&", function () {
      api.rerender('57d72a95', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/Monitor.vue"
export default component.exports